import { Handshake } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/lib/site";
import { Reveal } from "./motion-prims";

export const SPONSOR_LOGO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_donasi-bersama-1/artifacts/89d6e154ea947f3b_Desain%20tanpa%20judul%20%2830%29.png";

export default function Sponsor() {
  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Halo BANTU DONASI BERSAMA PR! Saya tertarik menjadi sponsor program donasi ini."
  )}`;

  return (
    <section id="sponsor" className="scroll-mt-20 py-20 sm:py-28">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-gold-dark">
            Sponsor &amp; Dukungan
          </p>
          <h2 className="mt-4 font-display font-black tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            Didukung oleh <span className="italic text-gold-dark">mereka yang peduli.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-10">
          <div className="grid md:grid-cols-[0.9fr_1.1fr] gap-6 items-stretch">
            <div
              data-testid="sponsor-section"
              className="relative bg-ink border-2 border-ink rounded-2xl shadow-retro-gold grid place-items-center p-8 overflow-hidden"
            >
              <div className="sunburst-dark absolute inset-0" aria-hidden="true" />
              <img
                src={SPONSOR_LOGO}
                alt="Logo sponsor buzzstore.id"
                data-testid="sponsor-logo"
                className="relative w-full max-w-[240px] object-contain"
              />
            </div>
            <div className="bg-paper border-2 border-ink rounded-2xl shadow-retro p-6 sm:p-8 flex flex-col justify-center gap-3">
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] bg-gold border-2 border-ink rounded-full px-3 py-1.5 w-fit">
                Sponsor Resmi
              </span>
              <h3 className="font-display font-black text-2xl sm:text-3xl">buzzstore.id</h3>
              <p className="text-sm sm:text-base text-pine leading-relaxed">
                Buzzstore.id turut mendukung Bantuan Donasi Bersama PR 2025 — gerakan bakti sosial
                panti jompo dari Divisi Public Relations.
              </p>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="sponsor-cta"
                className="btn-retro bg-gold text-ink rounded-full px-6 py-3 text-sm w-fit mt-2"
              >
                <Handshake className="w-4 h-4" /> Jadi Sponsor Berikutnya
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
